export default __webpack_public_path__ + "static/media/icon-selfie-uploader.9f23532a.svg";